export const calculateTrialDaysLeft = (createdDate) => {
  const trialDuration = 14; // days
  const currentDate = new Date();
  const startDate = new Date(createdDate);
  const diffDays = Math.ceil(
    (startDate.getTime() +
      trialDuration * 24 * 60 * 60 * 1000 -
      currentDate.getTime()) /
      (1000 * 60 * 60 * 24)
  );
  return diffDays > 0 ? diffDays : 0;
};
